<template>
  <!-- eslint-disable vue-a11y/form-has-label -->
  <div id="BigBank">
    <div class="heading d-flex">
      <h4>PIRKIMAS IŠSIMOKĖTINAI</h4>
      <Pic
        alt="Bigbank calculator"
        draggable="false"
        src="../../assets/bigbank/bigbank-logo.png" />
    </div>
    <table class="calculator">
      <tr>
        <td>Skolinuosi</td>
        <td class="flex">
          <button
            class="minus amount"
            type="button"
            @click="decrementAmount"
            @keydown.enter="decrementAmount" />
          <input
            v-model="amount"
            class="input amount"
            type="text"
            @blur="addAmountLabel"
            @change="checkAmountFromInput"
            @focus="removeAmountLabel">
          <button
            class="plus amount"
            type="button"
            @click="incrementAmount"
            @keydown.enter="incrementAmount" />
        </td>
      </tr>
      <tr>
        <td>Grąžinsiu per</td>
        <td class="flex">
          <button
            class="minus term"
            type="button"
            @click="decrementTerm"
            @keydown.enter="decrementTerm" />
          <input
            v-model="term"
            class="input term"
            type="text"
            @blur="addTermLabel"
            @change="checkTermFromInput"
            @focus="removeTermLabel">
          <button
            class="plus term"
            type="button"
            @click="incrementTerm"
            @keydown.enter="incrementTerm" />
        </td>
      </tr>
    </table>
    <p class="deposit">
      Mėnesio įmoka tik <span>{{ monthlyRepayment }}</span> €
    </p>

    <div class="marquee">
      <Marquee>
        <p>Pavyzdžiui, skolinantis 5000 Eur, kai sudaroma 120 mėn. sutartis, fiksuota metinė palūkanų norma – 4,6%, sutarties sudarymo mokestis – 1,9% (grąžinamas lygiomis dalimis per visą sutarties galiojimo laikotarpį), mėnesio įmoka – 52,85 Eur, bendra sumokama suma – 6342,27 Eur, bendra kredito kainos metinė norma – 5,04%.</p>
      </Marquee>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      amount: '5000 €',
      term: '120 mėn.',
    }
  },
  computed: {
    conclusionFee() {
      return parseInt(this.amount) * 0.019
    },
    monthlyRepayment() {
      return parseFloat(this.pmt(0.046 / 12, parseInt(this.term), -parseInt(this.amount), 0) + (this.conclusionFee / parseInt(this.term))).toFixed(2)
    },
  },
  methods: {
    checkAmountFromInput() {
      this.removeAmountLabel()
      const parsedAmount = parseInt(this.amount)
      if (parsedAmount < 3000) {
        this.amount = 3000
      } else if (parsedAmount > 13000) {
        this.amount = 14000
      }
    },
    checkTermFromInput() {
      this.removeTermLabel()
      const parsedTerm = parseInt(this.term)
      if (parsedTerm < 36) {
        this.term = 36
      } else if (parsedTerm > 114) {
        this.term = 120
      } else {
        this.term = parseInt(this.term) + 6
      }
    },
    incrementAmount() {
      this.removeAmountLabel()
      const parsedAmount = parseInt(this.amount)
      if (parsedAmount < 3000) {
        this.amount = 3000
      } else if (parsedAmount > 13000) {
        this.amount = 14000
      } else {
        this.amount = parseInt(this.amount) + 1000
      }
      this.addAmountLabel()
    },
    decrementAmount() {
      this.removeAmountLabel()
      const parsedAmount = parseInt(this.amount)
      if (parsedAmount > 14000) {
        this.amount = 14000
      } else if (parsedAmount < 4000) {
        this.amount = 3000
      } else {
        this.amount -= 1000
      }
      this.addAmountLabel()
    },
    incrementTerm() {
      this.removeTermLabel()
      const parsedTerm = parseInt(this.term)
      if (parsedTerm < 36) {
        this.term = 36
      } else if (parsedTerm > 114) {
        this.term = 120
      } else {
        this.term = parseInt(this.term) + 6
      }
      this.addTermLabel()
    },
    decrementTerm() {
      this.removeTermLabel()
      const parsedTerm = parseInt(this.term)
      if (parsedTerm > 120) {
        this.term = 120
      } else if (parsedTerm < 42) {
        this.term = 36
      } else {
        this.term -= 6
      }
      this.addTermLabel()
    },
    addAmountLabel() {
      if (!parseInt(this.amount)) {
        this.amount = 5000
      }
      if (this.amount[this.amount.length - 1] !== '€') {
        this.amount += ' €'
      }
    },
    removeAmountLabel() {
      if (this.amount[this.amount.length - 1] === '€') {
        this.amount = this.amount.split(' €')[0]
      }
    },
    addTermLabel() {
      if (!parseInt(this.term)) {
        this.term = 120
      }
      if (this.term[this.term.length - 1] !== '.') {
        this.term += ' mėn.'
      }
    },
    removeTermLabel() {
      if (this.term[this.term.length - 1] === '.') {
        this.term = this.term.split(' mėn.')[0]
      }
    },
    pmt(ratePerPeriod, numberOfPayments, presentValue, futureValue, type) {
      futureValue = typeof futureValue !== 'undefined' ? futureValue : 0
      type = typeof type !== 'undefined' ? type : 0

      if (ratePerPeriod !== 0) {
        // Interest rate exists
        const q = Math.pow(1 + ratePerPeriod, numberOfPayments)
        return -(ratePerPeriod * (futureValue + (q * presentValue))) / ((-1 + q) * (1 + ratePerPeriod * (type)))
      } else if (numberOfPayments !== 0) {
        // No interest rate, but number of payments exists
        return (-(futureValue + presentValue) / numberOfPayments).toFixed(2)
      }

      return 0
    },
  },
}
</script>

<style lang="scss" scoped>
$_bigbank-input: #00496a;
$_bigbank-cta-bg: #3cc88c;
$_bigbank-cta-border: darken(saturate($_bigbank-cta-bg, 5.33), 21.57);
$_bigbank-cta-bg-active: lighten(saturate($_bigbank-cta-bg, 3.02), 1.18);
$_bigbank-cta-bg-hover: darken(desaturate($_bigbank-cta-bg, 1.9), 3.14);
$_bigbank-font: 'Gotham Book', 'Gilroy', 'Helvetica', 'Arial';

@keyframes bob {
  0% {
    transform: translateZ(0);
  }

  25% {
    transform: translate3d(3px, 0, 0);
  }

  50% {
    transform: translateZ(0);
  }

  75% {
    transform: translate3d(3px, 0, 0);
  }

  to {
    transform: translateZ(0);
  }
}

#BigBank {
  background: url('../../assets/bigbank/bg.png') no-repeat;
  background-size: cover;
  border-radius: 5px;
  font-family: $_bigbank-font;
  height: 190px;
  padding-bottom: 5px;
  width: 280px;

  .flex {
    display: flex;
  }

  .heading {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 10px;

    h4 {
      align-items: center;
      color: $white;
      font-size: 12px;
      font-weight: $bold;
      justify-content: space-between;
      text-transform: uppercase;
    }

    img {
      height: 25px;
      padding-left: 10px;
      padding-top: 3px;
      width: 86px;
    }
  }

  table.calculator {
    color: $white;
    font-size: 14px;
    padding: 10px;
    padding-bottom: 5px;
    padding-top: 15px;
    width: 100%;
  }

  input.input {
    background: $white;
    border: 1px solid $white;
    color: $_bigbank-input;
    font-family: $_bigbank-font;
    font-size: 14px;
    font-weight: $bolder;
    max-width: 80px;
    padding: 5px;
    padding-bottom: 3px;
    text-align: center;

    &:focus {
      outline: 0;
    }
  }

  button.cta {
    background: $_bigbank-cta-bg;
    border: 0;
    border-bottom: 2px solid $_bigbank-cta-border;
    border-radius: 5px;
    color: $white;
    font-family: $_bigbank-font;
    font-size: 16px;
    font-weight: $heavy;
    padding: 10px 15px;
    text-transform: uppercase;
    transition: 0.2s all;

    &:hover {
      animation-play-state: paused;
      background: $_bigbank-cta-bg-hover;
      cursor: pointer;
    }

    &:focus {
      outline: 0;
    }

    &:active {
      background: $_bigbank-cta-bg-active;
    }
  }

  button.minus {
    background: transparent;
    background: url('../../assets/bigbank/minus.png') no-repeat;
    background-size: cover;
    border: 0;
    height: 20px;
    margin-right: 10px;
    width: 20px;

    &:hover {
      cursor: pointer;
      opacity: 0.5;
    }
  }

  button.plus {
    background: transparent;
    background: url('../../assets/bigbank/plus.png') no-repeat;
    background-size: cover;
    border: 0;
    height: 20px;
    margin-left: 10px;
    width: 20px;

    &:hover {
      cursor: pointer;
      opacity: 0.5;
    }
  }

  button.plus, button.minus {
    margin-top: 3px;

    &:focus {
      outline: 0;
    }
  }

  p.deposit {
    color: $white;
    font-size: 15px;
    margin-bottom: 5px;
    margin-top: 0;
    margin-top: 20px;
    text-align: center;
  }

  .marquee {
    height: 24px;
    margin-top: 18px;
    overflow: hidden;
    position: relative;
    width: 280px;

    p {
      font-family: $_bigbank-font;
      font-size: 15px;
      line-height: 20px;
      padding: 2px 0;
    }
  }
}
</style>
